import { Component, inject } from '@angular/core';
import { LanguageCode, LanguageService } from '../../services/language/language.service';

interface OfflineTexts {
  title: string;
  description: string;
  retry: string;
}

// Local on purpose: the phrases come from the backend, which is unreachable here.
const TEXTS: Record<LanguageCode, OfflineTexts> = {
  it: {
    title: 'Sei offline',
    description: 'UrbanHub ha bisogno della connessione. Controlla la rete: l\'app riparte da sola appena torna.',
    retry: 'Riprova',
  },
  en: {
    title: 'You are offline',
    description: 'UrbanHub needs a connection. Check your network: the app resumes on its own as soon as it is back.',
    retry: 'Retry',
  },
};

@Component({
  selector: 'urban-offline-page',
  templateUrl: './offline-page.component.html',
  styleUrl: './offline-page.component.scss',
})
export class OfflinePageComponent {
  readonly texts: OfflineTexts = TEXTS[inject(LanguageService).preferredLanguage()];

  // The startup calls fail one by one and nothing retries them: a reload runs
  // them all again in order, session included.
  retry(): void {
    window.location.reload();
  }
}
